import { render, staticRenderFns } from "./BarsLayeredChart.vue?vue&type=template&id=2d83388e"
import script from "./BarsLayeredChart.vue?vue&type=script&lang=js"
export * from "./BarsLayeredChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports